import { z } from "zod"
import { User } from "@/schemas/User"
import { ParsedAPIRes } from "@/types/types"
import { KyInstance } from "ky"

const SignInSchema = z.object({
  email: z.string().email("Must be a valid email address").min(1, "Must be a valid email address"),
  password: z.string().min(1, "Password is required"),
  recaptchaResponse: z.string(),
})

export type SignInInput = z.infer<typeof SignInSchema>

export type SignInKeys = keyof SignInInput

type ErrorCode =
  | "FALLBACK_ERROR"
  | "INVALID_RECAPTCHA"
  | "INVALID_COMBINATION"
  | "ACCOUNT_NOT_VERIFIED"
  | "FALLBACK_ERROR"

type Output = User

export type SignIn = (
  clientInstance: KyInstance,
  input: SignInInput,
) => ParsedAPIRes<Output, ErrorCode>

export function validateSignIn(input: SignInInput) {
  const { data, error } = SignInSchema.safeParse(input)

  if (error) {
    return [null, error.flatten().fieldErrors] as const
  }
  return [data, null] as const
}
